import { useEffect } from 'react';

import LogRocket from 'logrocket';

import { checkIfLogRocketInitialized } from 'src/app/storage/helpers';

export const useLogRocketInit = (args?: { condition?: boolean }) => {
  const isArgConditionMet = args?.condition ?? true;

  useEffect(() => {
    const isProd = process.env.NEXT_PUBLIC_CAPSULE_ENV === 'production';
    const hasLogRocketInitialized = checkIfLogRocketInitialized();

    const shouldInitLogRocket = isProd && isArgConditionMet && !hasLogRocketInitialized;

    if (shouldInitLogRocket) {
      LogRocket.init('capsule-dkomw/consumer-web', {
        dom: { textSanitizer: false, inputSanitizer: 'lipsum' },
        network: {
          responseSanitizer: res => {
            res.body = undefined;
            return res;
          },
          requestSanitizer: req => {
            req.body = undefined;
            return req;
          },
        },
      });
    }
  }, [isArgConditionMet]);

  return;
};
